import React, { memo, SVGProps } from 'react'

export const Checkmark = memo((props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M17.52 7.50816L10.0656 14.9645L6.48 11.377C6.19968 11.0966 5.74368 11.0947 5.46144 11.377C5.1792 11.6592 5.18016 12.1142 5.46144 12.3955L9.5568 16.4928C9.69216 16.6282 9.87456 16.704 10.0656 16.704C10.2566 16.704 10.44 16.6282 10.5744 16.4928L18.5376 8.52768C18.8189 8.2464 18.8189 7.7904 18.5376 7.50912C18.2563 7.22784 17.8003 7.22784 17.519 7.50912L17.52 7.50816Z"
      fill="currentColor"
    />
  </svg>
))
